import type { Router } from "@lit-labs/router";

import { withTransition } from "./motion";

let rootRouter: Router | undefined;

/** Registered once by `<app-root>` so guards and pages can navigate programmatically. */
export function setRootRouter(router: Router): void {
  rootRouter = router;
}

/** Programmatic navigation, equivalent to clicking a same-origin link to `pathname`. */
export async function navigate(pathname: string): Promise<void> {
  if (!rootRouter) {
    window.location.assign(pathname);
    return;
  }
  // Cross-fade the route change where the browser can, and fall straight
  // through where it cannot. withTransition resolves as soon as the DOM is
  // updated, so the animation never sits between the user and the next page.
  await withTransition(async () => {
    await rootRouter?.goto(pathname);
  });
}
